module.exports = __webpack_public_path__ + "img/habbox-logo.b3cd9a7e.gif";